import React, { cloneElement } from 'react';
import { Check, ChevronRight, BookOpen, Droplet, Calculator, Package, Calendar, Smartphone, Coffee, Gift, ShoppingBag, Star, X } from 'lucide-react';
import { FAQ } from './components/FAQ';
export function App() {
  return <div className="min-h-screen bg-[#F7F1E8] font-['Inter',sans-serif] text-[#5A3A28] selection:bg-[#E8B3C1] selection:text-[#5A3A28]" data-id="element-0" data-mp="3k78bh93vless">
      {/* 1. HERO SECTION */}
      <section id="hero" className="relative py-8 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1" data-mp="2rlf5kqna9k1s">
        <div className="flex-1 z-10 w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-2" data-mp="31ayq00qn9lyr">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#EF9F27] text-white font-semibold text-sm mb-8 shadow-sm" data-id="element-3" data-mp="2wka0gqyiyz29">
            <span data-id="element-4" data-mp="28suu8n3mnxlq">🔥 Precio de lanzamiento — Solo por tiempo limitado</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-[1.1] text-[#5A3A28]" data-id="element-5" data-mp="23ujmchww7x65">
            EMPRENDÉ CON <span className="text-[#ED93B1]" data-id="element-6" data-mp="3ii4s22026sok">MINICOOKIES</span>{' '}
            DESDE TU CASA
          </h1>

          <p className="text-lg sm:text-xl text-[#5A3A28]/80 mb-8 font-medium leading-relaxed" data-id="element-7" data-mp="3rc9e8848zfxr">
            Aprendé a producir, presentar y vender minicookies irresistibles con
            una app interactiva lista para usar.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-8" data-mp="2zm4wyibsb90r">
            {['Recetas probadas', 'Costos y precios sugeridos', 'Packaging recomendado', 'Plan para conseguir tus primeras ventas'].map((item, i) => <li key={i} className="flex items-center gap-3 text-lg font-medium" data-id="element-9" data-mp="3dkl58dpap7l0" data-mpi={i}>
                <div className="bg-[#C98A4B] rounded-full p-1" data-id="element-10" data-mp="nuhicimzqbua">
                  <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-11" data-mp="sudk0b87tr6o" />
                </div>
                {item}
              </li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-12" data-mp="34ndfy2z19zs">
            <a href="https://minicookies-lab.impultienda.ar/o/minicookies" target="_blank" rel="noopener" className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#5A3A28] hover:bg-[#4a2f20] text-white rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-13" data-mp="3ubzrw5cgz9c0">
              QUIERO ACCEDER AHORA
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-14" data-mp="3qaxu7sy7b5c5" />
            </a>
            <a href="#que-incluye" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-transparent hover:bg-[#5A3A28]/5 text-[#5A3A28] rounded-full font-bold text-lg transition-all duration-300 border-2 border-[#5A3A28]/20 hover:border-[#5A3A28]" data-id="element-15" data-mp="3lk7mwa67sset">
              VER TODO LO QUE INCLUYE
            </a>
          </div>

          <p className="mt-5 text-sm font-semibold text-[#5A3A28]" data-id="element-16" data-mp="1d4ztyvan96sk">
            USD $15 · Pago seguro internacional · Tarjeta de crédito o débito 💳
          </p>
          <p className="mt-1 text-sm text-[#5A3A28]/70 font-medium" data-id="element-17" data-mp="ydilmdnxtlwb">
            🔒 Acceso inmediato · De por vida · Sin suscripción
          </p>
        </div>

        <div className="flex-1 relative w-full max-w-2xl lg:max-w-none mx-auto" data-id="element-18" data-mp="1r5kbzp8qiyl0">
          <div className="absolute inset-0 bg-[#E8B3C1]/20 rounded-[2.5rem] transform rotate-3 scale-105 -z-10" data-id="element-19" data-mp="1w3lw8dhwd3y2"></div>
          <img src="https://cdn.magicpatterns.com/uploads/7Qsv58MeAQsJJ5h3eAKBBH/ChatGPT_Image_17_jun_2026,_07_48_28_p.m..png" alt="Minicookies Premium Mockup" className="rounded-[2.5rem] shadow-2xl object-cover w-full h-auto aspect-[4/5] lg:aspect-square" data-id="element-20" data-mp="1i2sw9d8ttgnk" />
        </div>
      </section>

      {/* 2. QUÉ INCLUYE */}
      <section id="que-incluye" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white" data-id="element-21" data-mp="qwvrie5a2n6d">
        <div className="max-w-[1400px] mx-auto" data-id="element-22" data-mp="m5x6505fmyw9">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-23" data-mp="m5458ft5n3m1">
            ¿QUÉ INCLUYE MINICOOKIES LAB?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-24" data-mp="c90voovz42p2">
            {[{
            icon: <BookOpen data-id="element-25" data-mp="19uov7inq714t" />,
            title: 'Recetas Premium',
            desc: 'Fórmulas exactas para cookies perfectas.'
          }, {
            icon: <Droplet data-id="element-26" data-mp="zx29ac80e9bc" />,
            title: 'Salsas para Dipping',
            desc: 'Complementos irresistibles para tus ventas.'
          }, {
            icon: <Calculator data-id="element-27" data-mp="3knt334sun1r1" />,
            title: 'Costos y Precios',
            desc: 'Calculadora automática de rentabilidad.'
          }, {
            icon: <Package data-id="element-28" data-mp="3goty5k74b4zl" />,
            title: 'Packaging y Conservación',
            desc: 'Presentaciones que enamoran a tus clientes.'
          }, {
            icon: <Calendar data-id="element-29" data-mp="203xolkd7toqf" />,
            title: 'Planner de Producción',
            desc: 'Organización paso a paso para escalar.'
          }, {
            icon: <Smartphone data-id="element-30" data-mp="29xeewee58lpc" />,
            title: 'App Interactiva',
            desc: 'Todo tu negocio en la palma de tu mano.'
          }].map((item, i) => <div key={i} className="bg-[#F7F1E8] p-8 rounded-3xl border border-[#5A3A28]/10 hover:border-[#C98A4B] transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-31" data-mp="2jsoih6k6x158" data-mpi={i}>
                <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#C98A4B] mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-32" data-mp="2ssblfwskif0e">
                  {cloneElement(item.icon, {
                className: 'w-8 h-8'
              })}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-33" data-mp="1wsqzzp5ty15s">{item.title}</h3>
                <p className="text-[#5A3A28]/70 font-medium" data-id="element-34" data-mp="1wukc3jz7pdl6">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* COMPARATIVA: NO ES OTRO PDF */}
      <section id="comparativa" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#E8B3C1]/10" data-id="element-35" data-mp="25va1o5xvq7qg">
        <div className="max-w-[1000px] mx-auto text-center" data-id="element-36" data-mp="2ko3lg3k6pa0x">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-[#5A3A28]" data-id="element-37" data-mp="2fqtvmmsvuwck">
            No es otro PDF
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium mb-12" data-id="element-38" data-mp="2tkupp38w3v6l">
            Es una herramienta interactiva diseñada para ayudarte a vender.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 text-left" data-id="element-39" data-mp="33hfrzgtiys6q">
            {/* PDF */}
            <div className="bg-white p-8 rounded-3xl border border-[#5A3A28]/10 opacity-70" data-id="element-40" data-mp="2yje7crggakt5">
              <h3 className="text-xl font-bold mb-6 text-[#5A3A28]/60" data-id="element-41" data-mp="3i46297p87v4g">
                PDF tradicional
              </h3>
              <ul className="space-y-4" data-id="element-42" data-mp="3n0n0iuq53pv9">
                {['Información dispersa', 'Solo lectura', 'Sin herramientas', 'Difícil de consultar mientras trabajás'].map((item, i) => <li key={i} className="flex items-center gap-3 text-[#5A3A28]/70 font-medium" data-id="element-43" data-mp="2zbkdf7cql4td" data-mpi={i}>
                    <X className="w-5 h-5 text-red-400 shrink-0" data-id="element-44" data-mp="2pfhc23ppla7h" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Minicookies Lab */}
            <div className="bg-[#5A3A28] p-8 rounded-3xl shadow-xl text-[#F7F1E8] transform md:-translate-y-2" data-id="element-45" data-mp="2gdrbo8dun0xk">
              <h3 className="text-xl font-bold mb-6 text-[#EF9F27]" data-id="element-46" data-mp="2ket9cks4b4xf">
                Minicookies <span className="text-[#ED93B1]" data-id="element-47" data-mp="30vx17o19hjhk">Lab</span>
              </h3>
              <ul className="space-y-4" data-id="element-48" data-mp="2vwapjj130bav">
                {['Todo organizado', 'Acceso inmediato desde celular', 'Calculadora incluida', 'Sistema paso a paso', 'Herramientas para vender'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-49" data-mp="2hx1aimom3n8h" data-mpi={i}>
                    <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-50" data-mp="2d5szjm7mvtt7" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <p className="text-2xl font-extrabold text-[#5A3A28]" data-id="element-51" data-mp="239g5uoc39fyg">
            Más que recetas. Un sistema completo para emprender.
          </p>
        </div>
      </section>

      {/* 3. MIRÁ LA APP POR DENTRO */}
      <section id="app" className="py-8 px-0 overflow-hidden" data-id="element-52" data-mp="1u91hth7qpmr9">
        <h2 className="sr-only" data-id="element-53" data-mp="9o4kh64umiyd">
          Mirá la app por dentro — todo lo que necesitás para emprender,
          organizado paso a paso
        </h2>
        <div className="m-0 p-0 overflow-hidden bg-black" data-id="element-54" data-mp="ipksj786y8zf">
          <img src="https://cdn.magicpatterns.com/uploads/sdPsykQ6HWFBv9BWR7coUf/ChatGPT_Image_22_jun_2026,_08_21_15_p.m..png" alt="Mirá la app por dentro: pantallas reales de recetas, primeras ventas y producción de la app Minicookies Lab" className="block w-full h-auto m-0 p-0 rounded-none border-0 shadow-none" data-id="element-55" data-mp="iq4486790150" />
        </div>
      </section>

      {/* 4. LO QUE PODÉS VENDER */}
      <section id="vender" className="py-8 px-6 lg:px-12 bg-white" data-id="element-56" data-mp="3w2o0165k846f">
        <div className="max-w-[1400px] mx-auto" data-id="element-57" data-mp="4re74qkfi1gn">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-16 text-[#5A3A28]" data-id="element-58" data-mp="33g3926szxu3e">
            LO QUE PODÉS VENDER
          </h2>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2" data-id="element-59" data-mp="38dbs09lyy25p">
            {[{
            title: 'Vasos de minicookies',
            desc: 'El formato estrella para consumo al paso.',
            icon: <Coffee className="w-5 h-5" data-id="element-60" data-mp="2k8b1kvt43omm" />
          }, {
            title: 'Bandejas para compartir',
            desc: 'Ideales para reuniones y regalos.',
            icon: <ShoppingBag className="w-5 h-5" data-id="element-61" data-mp="2u2behjumxy5w" />
          }, {
            title: 'Souvenirs',
            desc: 'Para cumpleaños, bodas y eventos.',
            icon: <Gift className="w-5 h-5" data-id="element-62" data-mp="21g045hh88ivw" />
          }, {
            title: 'Mesas dulces',
            desc: 'Propuestas premium para fiestas.',
            icon: <Star className="w-5 h-5" data-id="element-63" data-mp="2b6blc5px8okq" />
          }].map((item, i) => <div key={i} className="group relative rounded-2xl bg-[#F7F1E8] border border-[#5A3A28]/10 flex flex-col items-center justify-center px-[14px] py-[12px] text-center hover:bg-[#5A3A28] hover:text-white transition-colors duration-300" data-id="element-64" data-mp="1dp3535aj5g22" data-mpi={i}>
                <div className="text-[#C98A4B] mb-[4px] group-hover:text-[#E8B3C1] transition-colors" data-id="element-65" data-mp="3ryykuvr5ss17">
                  {item.icon}
                </div>
                <h3 className="text-[13px] font-bold mb-[2px]" data-id="element-66" data-mp="3n0n8oede65ft">{item.title}</h3>
                <p className="text-[11px] leading-[1.4] opacity-80 font-medium" data-id="element-67" data-mp="3i1twcp9uckh8">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. IDEAL PARA VOS SI... */}
      <section id="ideal" className="py-8 px-6 lg:px-12 relative" data-id="element-68" data-mp="347t6kl0va7t0">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/wnNrC9o8oofHrx9j3yxmfZ/ChatGPT_Image_18_jun_2026,_04_25_18_p.m..png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-69" data-mp="345yhcuikbtj4"></div>
        <div className="max-w-3xl mx-auto relative z-10 bg-white/90 backdrop-blur-md p-10 md:p-16 rounded-[2.5rem] shadow-xl border border-[#5A3A28]/10" data-id="element-70" data-mp="2fmofyg7l8ld4">
          <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-10 text-[#5A3A28]" data-id="element-71" data-mp="26mrok6ttd8ed">
            IDEAL PARA VOS SI...
          </h2>

          <ul className="space-y-6" data-id="element-72" data-mp="2ap4qek5fwm5v">
            {['Querés generar ingresos desde casa', 'Te gusta la cocina y los detalles', 'Buscás un emprendimiento de baja inversión', 'Querés vender por Instagram y WhatsApp', 'Necesitás un sistema paso a paso comprobado'].map((text, i) => <li key={i} className="flex items-center gap-4 text-lg md:text-xl font-medium" data-id="element-73" data-mp="2tmpg1tg13orj" data-mpi={i}>
                <div className="bg-[#E8B3C1] rounded-full p-1 shrink-0" data-id="element-74" data-mp="3hb8r2gqgqfnb">
                  <Check className="w-5 h-5 text-[#5A3A28]" strokeWidth={3} data-id="element-75" data-mp="3m4jz2l70h2gt" />
                </div>
                {text}
              </li>)}
          </ul>
        </div>
      </section>

      {/* AUTORIDAD */}
      <section id="autoridad" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-white text-center" data-id="element-76" data-mp="15ox2gbby9ajo">
        <div className="max-w-3xl mx-auto" data-id="element-77" data-mp="1kgfejy1oukxr">
          <div className="w-16 h-16 bg-[#E8B3C1]/30 rounded-full flex items-center justify-center mx-auto mb-6 text-[#5A3A28]" data-id="element-78" data-mp="1feq52mu46fbs">
            <Star className="w-8 h-8 fill-current" data-id="element-79" data-mp="rqgobzbrchri" />
          </div>
          <h2 className="text-3xl font-extrabold mb-6 text-[#5A3A28]" data-id="element-80" data-mp="mr3xl3hrmqjn">
            Creada para emprendedoras reales
          </h2>
          <p className="text-lg md:text-xl text-[#5A3A28]/80 font-medium leading-relaxed" data-id="element-81" data-mp="11ompgepqpjvb">
            Pensada para quienes quieren comenzar desde casa con baja inversión,
            vender por Instagram, WhatsApp, ferias o pedidos personalizados y
            transformar una receta en un negocio.
          </p>
        </div>
      </section>

      {/* PREGUNTAS FRECUENTES */}
      <FAQ data-id="element-82" data-mp="hnl80hw5ypyr" />

      {/* URGENCY BAND */}
      <section id="lanzamiento" className="scroll-mt-8 py-8 px-6 lg:px-12 bg-[#EF9F27] text-[#5A3A28] text-center" data-id="element-83" data-mp="howeipgzubtk">
        <div className="max-w-4xl mx-auto" data-id="element-84" data-mp="qn00tnzszcmf">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-4 flex items-center justify-center gap-2" data-id="element-85" data-mp="qlyeuoh915px">
            🔥 Precio de lanzamiento
          </h2>
          <p className="text-lg font-bold" data-id="element-86" data-mp="10m7e6b6jf79j">
            Acceso de por vida. Actualizaciones futuras incluidas.{' '}
            <br className="hidden md:block" data-id="element-87" data-mp="15jqr97ri1dzw" />
            <span className="font-medium opacity-90" data-id="element-88" data-mp="15iflx3ieny6o">
              El valor aumentará cuando se agreguen nuevos módulos y
              herramientas.
            </span>
          </p>
        </div>
      </section>

      {/* 6. OFERTA */}
      <section id="oferta" className="py-8 px-6 lg:px-12 bg-[#5A3A28] text-[#F7F1E8]" data-id="element-89" data-mp="1jcp09wwv74lx">
        <div className="max-w-4xl mx-auto text-center" data-id="element-90" data-mp="1ocbfud060wxw">
          <div className="inline-block bg-[#EF9F27] text-[#5A3A28] px-6 py-2 rounded-full font-bold tracking-widest text-sm mb-8 uppercase" data-id="element-91" data-mp="1o8xg7civz1u5">
            ⭐ Oferta de lanzamiento
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold mb-8" data-id="element-92" data-mp="1tigjiozvnrgb">
            Empezá esta semana
          </h2>

          <div className="flex flex-col items-center mb-12" data-id="element-93" data-mp="1kfp64jnfylm1">
            <span className="text-2xl text-[#F7F1E8]/50 line-through font-medium" data-id="element-94" data-mp="1kh8nkdku32pe">
              USD $22
            </span>
            <span className="text-5xl md:text-6xl font-extrabold text-white mt-1" data-id="element-95" data-mp="2h7j342e2nudg">
              USD $15
            </span>
            <span className="text-base text-[#F7F1E8]/80 font-medium mt-3" data-id="element-96" data-mp="27fd8ekwfqyuk">
              Pago seguro internacional · Tarjeta de crédito o débito
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-4 text-left max-w-xl mx-auto mb-12" data-id="element-97" data-mp="2zw64oax1i1ma">
            {['Recetas probadas', 'Calculadora de costos', 'Packaging recomendado', 'Plan para primeras ventas', 'Acceso inmediato'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-98" data-mp="y5p6hmszrvvz" data-mpi={i}>
                <Check className="w-5 h-5 text-[#EF9F27] shrink-0" strokeWidth={3} data-id="element-99" data-mp="jinm3btlcp35" />
                <span className="font-medium text-lg" data-id="element-100" data-mp="ofw339306n2t">{item}</span>
              </div>)}
          </div>

          <a href="https://minicookies-lab.impultienda.ar/o/minicookies" target="_blank" rel="noopener" className="w-full sm:w-auto group relative inline-flex items-center justify-center gap-2 px-10 py-5 bg-[#EF9F27] hover:bg-[#d98e1f] text-[#5A3A28] rounded-full font-extrabold text-xl transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1" data-id="element-101" data-mp="ag4l6x9d8mjj">
            QUIERO ACCEDER AHORA
            <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-102" data-mp="1zwm6yljyf2t9" />
          </a>

          <p className="mt-6 text-sm text-[#F7F1E8]/70 font-medium" data-id="element-103" data-mp="3kfg4jkvw4z48">
            Acceso de por vida • Sin suscripciones • Disponible desde cualquier
            dispositivo
          </p>
        </div>
      </section>
    </div>;
}